import {createCachedColumnSelector} from './createCachedColumnSelector';

export const usePinnedRightColumns = createCachedColumnSelector((col) => col.pinned === 'RIGHT');
